import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { getErrorMessage } from '../utils/validation';

/**
 * @name validateText
 * @description Right now this validation check is very simple, we're just
 * asserting that, when required a string (non-empty) exists.
 */
export const validateText = (
  question: CollectionSurveyQuestions,
  answer?: string
): string => {
  const { required, type } = question;

  if (type !== 'text' && type !== 'textarea') {
    throw new Error('Invalid question type');
  }

  // Not required and no value to validate
  if (!required && !answer) return '';

  const isValid = typeof answer === 'string' ? answer.trim() !== '' : false;

  return isValid ? '' : getErrorMessage(question);
};
